import { FC } from "react";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { Article } from "@/lib/types/Article";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";

interface IArticlesGridTop {
  topArticles: Article[];
}

const ArticlesGridTop: FC<IArticlesGridTop> = ({ topArticles }) => {
  const routes = useBrowserRoutes();
  const { t } = useTranslation();

  return (
    <>
      <div className="row g-5">
        <div className="col-lg-6 col-md-12 col-sm-12 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
          {topArticles.slice(0, 1).map(item => {
            const detailLink = routes.articleDetail.replace(":slug", item.Slug);

            return (
              <div className="rbt-card variation-02 height-330 rbt-hover" key={item.IdGuid}>
                <div className="rbt-card-img">
                  <Link href={detailLink}>
                    <Image src={item.ThumbImageUrl} width={638} height={330} priority alt={item.ImageAltText} />
                  </Link>
                </div>
                <div className="rbt-card-body">
                  <h3 className="rbt-card-title">
                    <Link href={detailLink}>{item.Title}</Link>
                  </h3>
                  <div className="rbt-card-bottom">
                    <Link className="transparent-button" href={detailLink}>
                      {t("articleDetails")}
                      <i>
                        <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g stroke="#27374D" fill="none" fillRule="evenodd">
                            <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                            <path strokeLinecap="square" d="M.663 5.572h14.594" />
                          </g>
                        </svg>
                      </i>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
          {topArticles.slice(1, 4).map((item, index) => {
            const detailLink = routes.articleDetail.replace(":slug", item.Slug);

            return (
              <div className={`rbt-card card-list variation-02 rbt-hover ${index !== 0 ? "mt--30" : ""}`} key={item.IdGuid}>
                <div className="rbt-card-img">
                  <Link href={detailLink}>
                    <Image src={item.ThumbImageUrl} width={580} height={300} priority alt={item.ImageAltText} />
                  </Link>
                </div>
                <div className="rbt-card-body">
                  <h5 className="rbt-card-title">
                    <Link href={detailLink}>{item.Title}</Link>
                  </h5>
                  <div className="rbt-card-bottom">
                    <Link className="transparent-button" href={detailLink}>
                      {t("articleDetails")}
                      <i>
                        <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g stroke="#27374D" fill="none" fillRule="evenodd">
                            <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                            <path strokeLinecap="square" d="M.663 5.572h14.594" />
                          </g>
                        </svg>
                      </i>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ArticlesGridTop;
